import _ from 'lodash';
import defaultState from 'us_pcb_assembly/data/defaultState';

import { PRICE_SELECTED, QUOTED } from 'shared/data/quoteSteps';

const state = {
  ...defaultState,
};

if (Spree.assemblyVariants) {
  state.assemblyVariants = Spree.assemblyVariants;
  state.currentVariant = Spree.assemblyVariants.us;
}

if (Spree.quote) {
  state.quote = Spree.quote;
}

if (Spree.quote_parameters) {
  if (!Spree.quote_parameters.bga) {
    Spree.quote_parameters.bga = '0';
  }

  ['lead_free', 'double_sided_smt', 'class_3_inspection'].forEach((key) => {
    Spree.quote_parameters[key] = Spree.quote_parameters[key]?.toString();
  });

  state.parameters = _.merge({}, state.parameters, Spree.quote_parameters);

  if (Spree.quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
}

if (Spree.currentUserEmail) {
  state.parameters.email_address = Spree.currentUserEmail;
}

export default state;
